module.exports = "<textarea class=form-control rows=\"{{rows || 3}}\" ng-model=ngModel ng-disabled=ngDisabled></textarea> ";